var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vgs-icon-set"},[_c(_vm.iconComponent,{tag:"component",staticClass:"inline-block fill-current",attrs:{"role":"img"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }